import { RE_SLUG_SPACE } from "@ihr-radioedit/inferno-core";

export const stripSpace = (value: string) => {
  return value.replace(RE_SLUG_SPACE(), "");
};
